import React, { useContext, useState } from 'react';
import { Analytics } from '@vercel/analytics/react';
import { ThemeContext } from './contexts/ThemeContext';
import './App.css';
import ThemeToggle from './components/ThemeToggle';
import RefreshButton from './components/RefreshButton';
import Header from './components/Header';
import MainContent from './components/MainContent';
import Footer from './components/Footer';
import Toast from './components/Toast';
import NotificationBanner, { checkIsBannerDismissed, markBannerDismissed } from './components/NotificationBanner';

const App: React.FC = () => {
  const { theme } = useContext(ThemeContext);
  const [isBannerDismissed, setIsBannerDismissed] = useState<boolean>(() => checkIsBannerDismissed());

  const isGamesOnlyView = React.useMemo(() => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('gamesOnly') === 'true';
  }, []);

  const handleDismissBanner = () => {
    markBannerDismissed();
    setIsBannerDismissed(true);
  };

  if (isGamesOnlyView) {
    return (
      <div className={`App ${theme} games-only-view`}>
        <MainContent />
        <Toast />
        <Analytics />
      </div>
    );
  }

  return (
      <div className={`App ${theme}`}>
        <NotificationBanner isDismissed={isBannerDismissed} onDismiss={handleDismissBanner} />
        <Header />
        <MainContent />
        <RefreshButton />
        <ThemeToggle />
        <Footer isBannerDismissed={isBannerDismissed} />
        <Toast />
        <Analytics />
      </div>
  );
}

export default App;